import Common from "../../../../Common"

export type CompanyWallboardQueueDummyCreateBody = {
	position: number
	type_option: number
	value_option: number
}

export type CompanyWallboardQueueDummyUpdateBody = CompanyWallboardQueueDummyCreateBody

const Dummy = class extends Common {
	create = (companyId: id, wallboardId: id, queueId: id, body: CompanyWallboardQueueDummyCreateBody) =>
		this.post(`/company/${companyId}/wallboard/${wallboardId}/queue/${queueId}/dummy`, body)

	update = (companyId: id, wallboardId: id, queueId: id, dummyId: id, body: CompanyWallboardQueueDummyUpdateBody) =>
		this.patch(`/company/${companyId}/wallboard/${wallboardId}/queue/${queueId}/dummy/${dummyId}`, body)

	delete = (companyId: id, wallboardId: id, queueId: id, dummyId: id) =>
		this.doDelete(`/company/${companyId}/wallboard/${wallboardId}/queue/${queueId}/dummy/${dummyId}`)
}

export default Dummy
